import type { CSSProperties } from 'react';

/**
 * Width of the name column in every integration row, so all toggles, gears and statuses line up.
 * Fits the longest name ("Zammad – Register a ticket" / "Zammad – Ticket erstellen"); a longer
 * name wraps instead of pushing its row's toggle out of line.
 */
export const INTEGRATION_LABEL_STYLE: CSSProperties = { width: 210, flexShrink: 0 };
